import { preconnect } from './chunk-IVW6GMZV.js';
import { $ariaBool } from './chunk-EVP5E6AO.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { $$_create_walker, $$_effect, $$_attr, $$_listen, $$_create_template } from 'maverick.js/dom';
import { signal, computed, effect } from 'maverick.js';
import { defineElement, Component } from 'maverick.js/element';

var $$_templ = /* @__PURE__ */ $$_create_template(`<!$><img part="img" />`);
var Poster = class extends Component {
  constructor() {
    super(...arguments);
    this.zb = signal(true);
    this.Rc = signal(false);
  }
  onAttach(el) {
    this.a = useMedia();
    this.Sc = computed(this.zh.bind(this));
    this.de = this.Ah.bind(this);
    this.setAttributes({
      "data-loading": this.zb,
      "aria-hidden": $ariaBool(this.Rc)
    });
  }
  onConnect(el) {
    const { canLoad, poster } = this.a.$store;
    window.requestAnimationFrame(() => {
      if (!canLoad())
        preconnect(poster());
    });
    this.a.remote.setTarget(el);
    this.a.remote.hidePoster();
    effect(this.ha.bind(this));
  }
  onDisconnect() {
    this.a.remote.showPoster();
  }
  zh() {
    const { canLoad, poster } = this.a.$store;
    return canLoad() && poster().length ? poster() : null;
  }
  Ah() {
    return this.Sc() ? this.$props.alt() : null;
  }
  ha() {
    const { canLoad, poster } = this.a.$store;
    const isLoading = canLoad() && !!poster();
    this.zb.set(isLoading);
    this.Rc.set(false);
  }
  Bh() {
    this.zb.set(false);
  }
  ia() {
    this.zb.set(false);
    this.Rc.set(true);
  }
  render() {
    const { crossorigin } = this.a.$store;
    return (() => {
      const [$$_root, $$_walker] = $$_create_walker($$_templ);
      $$_effect(() => $$_attr($$_root, "src", this.Sc()));
      $$_effect(() => $$_attr($$_root, "alt", this.de()));
      $$_effect(() => $$_attr($$_root, "crossorigin", crossorigin()));
      $$_listen($$_root, "load", this.Bh.bind(this));
      $$_listen($$_root, "error", this.ia.bind(this));
      return $$_root;
    })();
  }
};
Poster.el = defineElement({
  tagName: "media-poster",
  props: { alt: void 0 }
});

export { Poster };
